import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";

// ui
import { TextFieldForm } from "@/components/Elements/Forms/TextFieldForm";
import { StackItem } from "@/components/Elements/Layouts/Stack";
import { InputLabel } from "@/components/Elements/Texts/InputLabel";
import { UserText } from "@/components/Elements/Texts/UserText";

// components
import {
  NextNavigaterButton,
  PropertyTypeSelector,
} from "@/features/LG/components/shared";
import { PostcodeForm, PropertyNameForm } from "./components";

// state
import { IInputPage1, Page1State } from "@/store/propertyState";

export const InputPage1: React.FC<{ next: string }> = ({ next }) => {
  // global state
  const [pageValue, setPageValue] = useRecoilState(Page1State);

  // react-hook-form
  const form = useForm<IInputPage1>({
    mode: "onChange",
    // criteriaMode: "all",
    defaultValues: pageValue,
  });

  // これがないと値が更新されない
  useEffect(() => {
    reset(pageValue);
  }, [pageValue]);

  const {
    formState: { isValid },
    handleSubmit,
    reset,
  } = form;

  // urlのパスを取得
  return (
    <>
      <UserText>
        査定したい物件の種類を選択し、物件の情報を入力してください（1/3)
      </UserText>

      <PropertyTypeSelector />

      <PropertyNameForm form={form} />

      <PostcodeForm form={form} />

      <div>
        <InputLabel required label="都道府県・市区群・町名" />
        <TextFieldForm
          form={form}
          name="locationArea"
          placeholder="東京都中央区日本橋"
          rules={{
            required: {
              value: true,
              message: "この項目は必須です",
            },
          }}
        />
      </div>

      <div>
        <InputLabel required label="丁目以降" />
        <TextFieldForm
          form={form}
          name="locationDetail"
          placeholder="1-1-1"
          rules={{
            required: {
              value: true,
              message: "この項目は必須です",
            },
          }}
        />
      </div>

      <StackItem>
        <NextNavigaterButton
          label="次へ"
          isValid={isValid}
          next={next}
          onClick={handleSubmit((d) => {
            setPageValue(d);
          })}
        />
      </StackItem>
    </>
  );
};
